module.exports = __webpack_public_path__ + "static/media/search_icon.e768c58f.png";